import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@core/services/auth.store';

/**
 * Stops the user from accessing the route if logged in
 * Returns the user to the home page if logged in
 */
export const alreadyLoggedInGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

   if (authStore.isLoggedIn()) {
    await router.navigate(['/']);
    return false;
  }
  return true;
};
